
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DomesticProjectTaggingService {

  url ={
		getProjectIdData : '/loadJsonObject?action_code=s1rn3u',
		saveSourcingTaggingData :'/saveJsonObject?action_code=tvt6nl',
		getTagModal : '/loadJsonObject?action_code=ho5q8f',
    deleteSourcingTaggingData:'/saveJsonObject?action_code=90ek34'
	}
  durationInSeconds= 5;

  constructor(private httpClient: HttpClient, private http:HttpClient, private _snackBar: MatSnackBar, private gtwSnackbar: GtwSnackbarService) { }


	getProjectIdData(baseURL:string, tax_year: any,scenario:any){
		const options= {
			withCredentials: true,
			headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
		};
		const url = `${baseURL}${this.url.getProjectIdData}`;

		const body = `tax_year=${encodeURIComponent(tax_year)}&scenario=${encodeURIComponent(scenario)}`;

		return this.http.post(url, body, options).pipe(
			map((res:any) => {
				if(res.callSuccess == "1"){
				return res.jsonObject;
				}
				this.openSnackBar('Unable to fetch data.','gtw-snackbar--red');
				throwError(new Error('oops!'));
				return null;
			}
		));
	}

	getSourceTaggingModalData(baseURL:string, tax_year: any,scenario:any,jcd_key:any, taggingParam:any){
		const options= {
			withCredentials: true,
			headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
		};
		const url = `${baseURL}${this.url.getTagModal}`;

		const params: Record<string, string> = {
			tax_year: String(tax_year),
			scenario: String(scenario),
			jcd_key: String(jcd_key),
			filing_group: String(taggingParam.FILING_GROUP ?? ''),
			bsla_code: String(taggingParam.BSLA_CODE ?? ''),
			country_code: String(taggingParam.COUNTRY_CODE ?? ''),
			dcs_post_flip: String(taggingParam.DCS_POST_FLIP ?? ''),
			fse_pre_flip: String(taggingParam.FSE_PRE_FLIP ?? ''),
			fse_source_code: String(taggingParam.FSE_SOURCE_CODE ?? ''),
			fsi_source_code: String(taggingParam.FSI_SOURCE_CODE ?? ''),
			income_category: String(taggingParam.INCOME_CATEGORY ?? ''),
			income_category_type: String(taggingParam.INCOME_CATEGORY_TYPE ?? ''),
			payor_cdr: String(taggingParam.PAYOR_CDR ?? ''),
			payor_leid: String(taggingParam.PAYOR_LEID ?? ''),
			pti_subtype: String(taggingParam.PTI_SUBTYPE ?? ''),
			recipient_cdr: String(taggingParam.RECIPIENT_CDR ?? ''),
			recipient_leid: String(taggingParam.RECIPIENT_LEID ?? ''),
			reporting_period: String(taggingParam.REPORTING_PERIOD ?? ''),
			source: String(taggingParam.SOURCE ?? ''),
			sch_m_template_id: String(taggingParam.SCH_M_TEMPLATE_ID ?? ''),
			ownership_pct: String(taggingParam.OWNERSHIP_PCT ?? ''),
		};
		const body = Object.entries(params).map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');

		return this.http.post(url, body, options).pipe(
			map((res:any) => {
				if(res.callSuccess == "1"){
				return res.jsonObject;
				}
				this.openSnackBar('Unable to fetch data.','gtw-snackbar--red');
				throwError(new Error('oops!'));
				return null;
			}
		));
	}

	saveProjectTaggingData(baseURL : string, jsonData : any, tax_year: any,scenario:any,jcd_key:any,sso_id:any,baseGlobalParams: any, taggingParam:any,checkLockedObj: any) {
		const url = `${baseURL}${this.url.saveSourcingTaggingData}`;
		const options={
		  withCredentials: true
		};
	
		const data:any = {
		"tax_year":tax_year,
		"scenario":scenario,
		"jcd_key":jcd_key,
		"sso_id":sso_id,
		"filing_key": taggingParam.FILING_GROUP,
		"is_issue_key_enabled":baseGlobalParams.is_issue_key_enabled,
		"clob_data": JSON.stringify(jsonData),
		"scenarioCode":baseGlobalParams.scenarioCode,
		"checkLockedbj": checkLockedObj,
		};
	
		const formData = new FormData();
		Object.keys(data).forEach((key) => formData.append(key, data[key]));
	
		console.log('formData =', formData);
		console.log('data =', data);
	
	
		console.log('tax_year = ', formData.get("tax_year"));
		console.log('scenario = ', formData.get("scenario"));
		console.log('jcd_key = ', formData.get("jcd_key"));
		console.log('screen_key =', formData.get("screen_key"));
		console.log('sso_id =', formData.get("sso_id"));
		console.log('clob_data = ', formData.get("clob_data"));
	
	
	
		return this.http.post<any>(url, formData,options);
	  }

    deleteProjectTaggingData(baseURL : string, seq_key : any, tax_year: any,scenario:any,jcd_key:any,sso_id:any,baseGlobalParams: any, taggingParam:any,checkLockedObj: any) {
      const url = `${baseURL}${this.url.deleteSourcingTaggingData}`;
      const options={
        withCredentials: true
      };
    
      const data:any = {
      "tax_year":tax_year,
      "scenario":scenario,
      "jcd_key":jcd_key,
      "sso_id":sso_id,
      "filing_key": taggingParam.FILING_GROUP,
      "is_issue_key_enabled":baseGlobalParams.is_issue_key_enabled,
      "seq_key": seq_key,
      "scenarioCode":baseGlobalParams.scenarioCode,
      "checkLockedbj": checkLockedObj,
      };
    
      const formData = new FormData();
      Object.keys(data).forEach((key) => formData.append(key, data[key]));
    
      console.log('formData =', formData);
      console.log('data =', data);
    
    
      console.log('tax_year = ', formData.get("tax_year"));
      console.log('scenario = ', formData.get("scenario"));
      console.log('jcd_key = ', formData.get("jcd_key"));
      console.log('screen_key =', formData.get("screen_key"));
      console.log('sso_id =', formData.get("sso_id"));
      console.log('clob_data = ', formData.get("seq_key"));
    
    
    
      return this.http.post<any>(url, formData,options);
      }



  openSnackBar(message: string, panelClass: string = '') {
    this.gtwSnackbar.openSnackBar(message, (panelClass || '') as any, true, this.durationInSeconds);
  }

}
